import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Checkbox, Flex } from '@chakra-ui/react'
import { Table, Tbody, Td, Th, Thead, Tr } from '../../../components/Table'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { user } from '../../../helpers/user'
import { cnpjMask } from '../../../utils/cnpjMask'
import { formatPrice } from '../../../utils/formatPrice'
import { Button } from './Button'
import { FaRegArrowAltCircleLeft } from 'react-icons/fa'
import { useState } from 'react'

async function getInfoCliente({ codigo_vendedor, nome_cliente, cpf_cnpj, codigo_parceiro, email_cliente }) {
  const response = await api.get('https://api.innovationbrindes.com.br/api/chamado/lista-informacoes-chamados-filtro', {
    params: {
      codigo_vendedor,
      nome_cliente,
      cpf_cnpj,
      codigo_parceiro,
      email_cliente,
    },
  })

  return response.data?.map((item) => {
    return {
      ...item,
      codigo_cliente: item.codigo_parceiro,
      cpf_cnpj: cnpjMask(item.cpf_cnpj),
      razao_social: item.razao_social,
      email_cliente: item.email_cliente,
      total_pedidos: item.total_pedidos,
      valor_pedidos: formatPrice(item.valor_pedidos),
    }
  })
}

export function ModalCliente({ isOpen, onOpen, onClose, value, handleClientesSelected }) {
  const [customersSelected, setCustomersSelected] = useState([])

  const { data: infoModal = [], isLoading } = useQuery({
    queryKey: ['clientes', value],
    queryFn: () =>
      getInfoCliente({
        codigo_vendedor: user?.codigo_vendedor,
        nome_cliente: value.NomeCliente,
        cpf_cnpj: value.CpfCnpj,
        codigo_parceiro: value.CodigoCliente,
        email_cliente: value.Email,
      }),
    //toda vez qeu abrir
    enabled: isOpen,
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })

  function selectCustomer(customer) {
    setCustomersSelected((old) => {
      if (old.includes(customer)) {
        return old.filter((item) => item !== customer)
      } else {
        return [...old, customer]
      }
    })
  }

  function confirmCustomers() {
    handleClientesSelected(customersSelected)
    onClose()
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="full" motionPreset="slideInBottom">
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody mb={20}>
            <Table>
              <Thead>
                <Tr>
                  <Th bgColor="white" />
                  <Th bgColor="white" color="#378BBF">
                    Código cliente
                  </Th>
                  <Th bgColor="white" color="#378BBF">
                    CPF/CNPJ
                  </Th>
                  <Th bgColor="white" color="#378BBF">
                    Razão social
                  </Th>
                  <Th bgColor="white" color="#378BBF">
                    Pedidos total
                  </Th>
                  <Th bgColor="white" color="#378BBF">
                    Valor total
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {infoModal.map((data) => (
                  <Tr key={data.codigo_cliente}>
                    <Td>
                      <Flex alignItems="center" justifyContent="center" h="100%" w="100%">
                        <Checkbox
                          size="lg"
                          colorScheme="blue"
                          borderColor="#378BBF"
                          onChange={() => selectCustomer(data)}
                          isChecked={customersSelected.includes(data)}
                        />
                      </Flex>
                    </Td>
                    <Td>{data.codigo_parceiro}</Td>
                    <Td>{data.cpf_cnpj}</Td>
                    <Td>{data.razao_social}</Td>
                    <Td>{data?.email_cliente}</Td>
                    <Td>{data.total_pedidos}</Td>
                    <Td>{data.valor_pedidos}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </ModalBody>

          <ModalFooter borderTop="1px solid black" mt={4} position="fixed" bottom="0" w="100%" bgColor="white" zIndex="1000">
            <Flex gap={5} w="full" justifyContent="center" alignItems="center" cursor="pointer">
              <Flex onClick={onClose} gap={3} alignItems="center">
                <FaRegArrowAltCircleLeft />
                voltar
              </Flex>
              <Button onClick={confirmCustomers}>confirmar</Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
